/**
 * QuotationsDesktop Component
 * 
 * Desktop targeted QuotationsDesktop
 */

import React, { Component, Fragment } from 'react';

import appStore from '../../../redux/store/appStore';

import { getConfItem } from '../../../conf/conf';

import { getItem } from '../../../helpers/object-helper';

import {
    nextSunday,
    dateFormat
} from '../../../helpers/date-helper';

import './QuotationsDesktop.css';

import quotationKwh5Img from '../../../images/quotations/quotation-kwh5.jpg';
import quotationKwh10Img from '../../../images/quotations/quotation-kwh10.jpg';
//import advisedImg from '../../../images/quotations/advised.png';

const imagesBasePath = getConfItem('gui.images.basePath');
const imgLabelsDummyUrl = '/images/quotations-labels-dummy.jpg';
const docsBasePath = getConfItem('gui.docs.basePath');

class QuotationsDesktop extends Component {

    constructor(props) {
        super(props);
        this.state = {
            mapStaticImageUrl: props.mapStaticImageUrl,
            loading: props.loading,
            config: props.config,
            data: props.data,
            onSubmit: props.onSubmit,
            onQuoteChooseButtonClick: props.onQuoteChooseButtonClick
        };
    }

    componentDidMount() {
        this.labelInfoSetup();
    }

    /**
     * React getDerivedStateFromProps(nextProps, prevState) lifecycle method implementation
     * Updates this.state.mapStaticImageUrl
     * @param {*} nextProps 
     * @param {*} prevState 
     */
    static getDerivedStateFromProps(nextProps, prevState) {
        return Object.assign(prevState, {
            mapStaticImageUrl: nextProps.mapStaticImageUrl
        });
    }

    getConfig() {
        return this.props.config;
    }

    /**
     * =========================================================================== label infos popups management
     * Relies on
     *  this.labelInfoCreated {Object}
     *      Sample
     *          {
     *              'ottimizzatori': {HTMLElement}
     *          }
     *  this.labelInfoShowedNow {String}
     *      Sample
     *          'ottimizzatori'
     */

    /**
     * Sets label info management setup
     */
    labelInfoSetup() {

        const responsiveState = getItem('gui.responsive', appStore.getState());

        // label infos related properties
        this.labelInfoCreated = {};
        this.labelInfoShowedNow = null;

        // label infos click handler
        this.onLabelInfoEvent = this.onLabelInfoEvent.bind(this);

        if (responsiveState !== 'desktop') {
            // page click handler (to delete currently shown label infos when clicking anywhere in the page)
            this.onLabelInfoClickAnywhere = this.props.onLabelInfoClickAnywhere.bind(this);
            document.querySelector('.slc-page-quotations').addEventListener('click', this.onLabelInfoClickAnywhere);
        }

    }

    /**
     * Event handler for label info icons
     * The event type depends on the gui responsive state:
     *  - mouseover/mouseout for desktop devices
     *  - click for mobile/tablet devices
     * If some info is found for the label item, the info popup (content) creation/deletion is managed
     * @param {Event} evt 
     */
    onLabelInfoEvent(evt) {

        const dataId = evt.target.getAttribute('data-id');
        const labelInfo = getItem(dataId + '.info', this.getConfig());
        if (labelInfo) {
            this.labelInfoContentManage(dataId, labelInfo, evt.target);
        }
    }

    /**
     * Manages label infos popups
     * @param {String} dataId
     *  Sample
     *      'ottimizzatori'
     * @param {String} htmlContent 
     * @param {HTMLElement} labelInfoIconElement 
     */
    labelInfoContentManage(dataId, htmlContent, labelInfoIconElement) {
        if (this.labelInfoCreated[dataId]) {
            this.labelInfoContentDelete(dataId);
        } else {
            if (this.labelInfoShowedNow) {
                this.labelInfoContentDelete(this.labelInfoShowedNow);
            }
            this.labelInfoContentCreate(dataId, htmlContent, labelInfoIconElement)
        }
    }

    /**
     * Creates label info popup for dataId label
     * @param {String} dataId
     *  Sample
     *      'ottimizzatori'
     * @param {String} htmlContent 
     * @param {HTMLElement} labelInfoIconElement 
     */
    labelInfoContentCreate(dataId, htmlContent, labelInfoIconElement) {
        const infoContent = document.createElement('div');
        infoContent.setAttribute('class','slc-data-label-info-content slc-position-vertical-middle');
        infoContent.innerHTML = htmlContent;
        infoContent.addEventListener('click', function() {
            this.labelInfoContentDelete(dataId);
        }.bind(this));
        labelInfoIconElement.appendChild(infoContent);
        this.labelInfoCreated[dataId] = infoContent;
        this.labelInfoShowedNow = dataId;
    }

    /**
     * Deletes label info popup for dataId label
     * @param {String} dataId
     *  Sample
     *      'ottimizzatori'
     * @param {String} htmlContent 
     * @param {HTMLElement} labelInfoIconElement 
     */
    labelInfoContentDelete(dataId) {
        const infoElement = document.querySelector('.slc-data-' + dataId + ' .slc-data-label-info');
        const infoContent = document.querySelector('.slc-data-' + dataId + ' .slc-data-label-info-content');
        infoElement.removeChild(infoContent);
        this.labelInfoCreated[dataId] = null;
        delete this.labelInfoCreated[dataId];
        this.labelInfoShowedNow = null;
    }
    
    /**
     * =========================================================================== render
     */

    /**
     * Renders the images row JSX
     */
    renderImagesRow() {
        return (
            <div className="slc-quotations-row slc-quotations-row-images">
                <div className="slc-quotations-cell slc-quotations-cell-image">
                    <img className="slc-quotations-image" src={this.state.mapStaticImageUrl} alt="" />
                </div>
                <div className="slc-quotations-cell slc-quotations-cell-image">
                    {this.renderImageKwh5()}
                </div>
                <div className="slc-quotations-cell slc-quotations-cell-image">
                    {this.renderImageKwh10()}
                </div>
            </div>
        );
    }

    renderImageKwh5() {
        return (
            <Fragment>
            <img className="slc-quotations-image" src={quotationKwh5Img} alt="" />
            {this.renderImageAdvised('kwh5')}
            </Fragment>
        );
    }

    renderImageKwh10() {
        return (
            <Fragment>
            <img className="slc-quotations-image" src={quotationKwh10Img} alt="" />
            {this.renderImageAdvised('kwh10')}
            </Fragment>
        );
    }

    /**
     * Renders the advised.png <image/> for impianto if that the case
     * @param {String} impianto 
     */
    renderImageAdvised(impianto) {
        const advisedImpianto = getItem('quotations.advisedImpianto', appStore.getState());
        if (advisedImpianto === impianto) {
            return <div class="slc-quotation-best-choice">Consigliato</div>;
            //return <img className={`slc-quotations-image-advised slc-quotations-image-advised--${ impianto }`} src={advisedImg} alt="" />;
        } else {
            return null;
        }
    }

    /**
     * Renders the JSX representing all the rows with the quotations data
     *  data label - data value basic - data value plus
     *  Data is retrieved the following priority rules:
     *  1. From data[dataId] (data is passed down from PageQuotations.state.data), if any
     *  2. From config[dataId].values, if any
     *  3. Defaults to {basic: '', plus: ''}, if none of the preceeding rules is matched
     */
    renderData() {
        const config = this.getConfig();
        const data = this.props.data;
        const jsx = [];
        for (let dataId in config) {
            let rowLabel = config[dataId].label;
            let rowData;
            //console.log('>>> row label = ', rowLabel);
            if (data && data[dataId]) {
                rowData = data[dataId];
            } else {
                rowData = (config[dataId] && config[dataId].values) ? config[dataId].values : {kwh5: '', kwh10: ''};
            }
            //console.log('>>> row data = ', rowData);
            jsx.push(this.renderDataRow(dataId, rowLabel, rowData));
        }        
        return jsx;
    }

    /**
     * Renders a data row
     *  data label - data value basic - data value plus
     * Data rows include all data coming from the server, from 'Sistema Solare' to 'Scegli il tuo sistema'
     * @param {String} dataId 
     *  Sample
     *      sistemaSolare
     * @param {String} label 
     *  Sample
     *      'Sistema solare'
     * @param {Object} values
     *  .basic {Mixed}
     *  .plus {Mixed}
     *  Sample
     *      {
     *          basic: 'IKEA Solstrale Basic',
     *          plus: 'IKEA Solstrale Plus'
     *      }
     * 
     * @usage
     *  this.renderDataRow('sistemaSolare', 'Sistema solare', {basic:  'IKEA Solstrale Basic', plus: 'IKEA Solstrale Plus'})
     *  this.renderDataRow('potenza', 'Potenza', {basic: '5,23 kWp', plus: '5,40 kWp'})
     *  this.renderDataRow('numeroPannelli', 'Numero pannelli', {basic: 19, plus: 18})
     */
    renderDataRow(dataId, label, values) {

        const valueGuiFn = getItem(dataId + '.valueGuiFn', this.getConfig());
        const labelInfo = getItem(dataId + '.info', this.getConfig());
        
        // value basic
        //var valueBasic = (valueGuiFn) ? valueGuiFn(values.kwh5) : values.kwh5 ;

        var valueBasic = (valueGuiFn) ? valueGuiFn(values.kwh5, {
            quotationType: 'kwh5',
            values
        }) : values.kwh5 ;

        // value plus
        //var valuePlus = (valueGuiFn) ? valueGuiFn(values.kwh10) : values.kwh10 ;

        var valuePlus = (valueGuiFn) ? valueGuiFn(values.kwh10, {
            quotationType: 'kwh10',
            values
        }) : values.kwh10 ;

        // value basic JSX
        const valueBasicJSX = (values.kwh5) ? (
            <div className="slc-data-value slc-data-value-basic">
            {valueBasic}
            </div>) : null;

        // value plus JSX
        const valuePlusJSX = (values.kwh10) ? (
            <div className="slc-data-value slc-data-value-plus">
            {valuePlus}
            </div>) : null;

        const valueButtonBasicJSX = this.renderDataValueButton(dataId, 'kwh5');
        const valueButtonPlusJSX = this.renderDataValueButton(dataId, 'kwh10');

        if (dataId === 'scegli') {
            //label = '';
            //label = `*Offerta valida fino al ${ dateFormat(nextSunday()) }`;
            label = this.renderNavButtons();
        }

        // Label Info is handled onClick for mobile and onMouseOver/onMouseOut for desktop
        let labelInfoIconJSX = null;
        if (labelInfo) {
            if (getItem('gui.responsive', appStore.getState()) === 'desktop') {
                labelInfoIconJSX = <div className="slc-data-label-info" data-id={dataId} onMouseOver={this.onLabelInfoEvent} onMouseOut={this.onLabelInfoEvent}>?</div>
            } else {
                labelInfoIconJSX = <div className="slc-data-label-info" data-id={dataId} onClick={this.onLabelInfoEvent}>?</div>
            }
        }        

        // css class for this row
        const dataClassName = 'slc-quotations-row slc-quotations-row-data slc-data-' + dataId;

        return (
            <div key={dataId} className={dataClassName}>
                <div className="slc-quotations-cell slc-quotations-cell-data">
                    <div className="slc-data-label">
                    {label}
                    {labelInfoIconJSX}
                    </div>
                </div>
                <div className="slc-quotations-cell slc-quotations-cell-data">
                    {valueBasicJSX}
                    {valueButtonBasicJSX}
                </div>
                <div className="slc-quotations-cell slc-quotations-cell-data">
                    {valuePlusJSX}
                    {valueButtonPlusJSX}
                </div>
            </div>
        );
        
    }

    /**
     * Renders select quotation buttons
     * @param {String} dataId 
     * @param {String} dataValueType 
     */
    renderDataValueButton(dataId, dataValueType) {
        var className = 'slc-data-value-button' +
                        ' slc-data-value-button--' + dataId + '-' + dataValueType;
        var dataOptionId = dataId + '-' + dataValueType;
        var dataValueTypeLabel = (this.props.data) ? this.props.data.sistemaAccumulo[dataValueType] : '';
        var buttonLabel = 'Richiedi l\'offerta*';
        var button = null;
        var buttonJSX = (
            <div className={ className } data-option-id={ dataOptionId }>
                <button
                    className="slc-button-quotation slc-button btn btn-primary btn-lg"
                    onClick={ this.state.onQuoteChooseButtonClick }>
                    { buttonLabel }
                </button>
            </div>
        );
        switch (true) {
            case (dataId === 'scegli'):
                button = buttonJSX;
                break;
            default:
                button = null;
        }
        return button;
    }

    renderNavButtons() {
        return (
            <div className="slc-data-label slc-quotations-nav-buttons-container">
                <button
                    className="slc-quotations-nav-button btn btn-next btn-primary btn-lg"
                    id="slc-btn-backToWizard"
                    onClick={ this.props.navigateBack }>
                    Indietro
                </button>
                <button
                    className="slc-quotations-nav-button btn btn-next btn-primary btn-lg"
                    id="slc-btn-restart"
                    onClick={ this.props.navigateToWizard }>
                    Restart
                </button>
            </div>
        );
    }

    renderAdditionalRows() {
        //return null;
        
        return (
            <Fragment>
                <div className="slc-quotations-row slc-quotations-row-generic slc-quotations-legge-di-bilancio">
                    <div className="slc-quotations-cell">
                        <div className="slc-data-label">
                        (*) Per dettagli sulle detrazioni fiscali si veda Legge di Bilancio 2020 (L. 27.12.2019 n.160) e Legge 17 luglio 2020, n. 77, di conversione del D.L. 19 maggio 2010, n. 34, art 121
                        </div>
                    </div>
                </div>
            </Fragment>
        );
        
    }

    render() {
        return (
            <div className='slc-quotations'>
                {this.renderImagesRow()}
                {this.renderData()}
                {this.renderAdditionalRows()}
            </div>
        );
    }
}

export default QuotationsDesktop;